"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

const jsx_runtime_1 = require("react/jsx-runtime");

const react_1 = require("react");

const loadScript = (docum, scriptTagName, id, scriptSrc, callback, onError) => {
  const element = docum.getElementsByTagName(scriptTagName)[0];
  const someOtherScript = element;
  const script = docum.createElement(scriptTagName);
  script.id = id;
  script.src = scriptSrc;
  script.async = true;

  if (someOtherScript && someOtherScript.parentNode) {
    someOtherScript.parentNode.insertBefore(script, someOtherScript);
  } else {
    docum.head.appendChild(script);
  }

  script.onError = onError;
  script.onload = callback;
};

const removeScript = (docum, id) => {
  const element = docum.getElementById(id);

  if (element) {
    var _element$parentNode;

    (_element$parentNode = element.parentNode) === null || _element$parentNode === void 0 ? void 0 : _element$parentNode.removeChild(element);
  }
};

const GoogleSigninButton = ({
  callback,
  clientId,
  width
}) => {
  const googleButtonOpt = {
    theme: 'outline',
    // size: "medium",
    type: 'standard',
    text: 'continue_with',
    shape: 'rectangular',
    logo_alignment: 'center',
    width: '' + width || undefined
  };
  const divRef = (0, react_1.useRef)(null); //const [scriptLoaded, setScriptLoaded] = useState(false);

  (0, react_1.useEffect)(() => {
    loadScript(document, 'script', 'google-login', 'https://accounts.google.com/gsi/client', () => {
      //setScriptLoaded(true);
      window.google.accounts.id.initialize({
        client_id: clientId,
        callback: callback
      });

      if (divRef.current) {
        window.google.accounts.id.renderButton(divRef.current, googleButtonOpt);
      } // google.accounts.id.prompt(); // also display the One Tap dialog

    });
    return function cleanup() {
      removeScript(document, 'google-login');
    };
  }, []);
  return (0, jsx_runtime_1.jsx)("div", {
    ref: divRef
  }, void 0);
};

const GoogleSigninButtonHTML = ({
  callback,
  clientId,
  width
}) => {
  (0, react_1.useEffect)(() => {
    if (typeof window !== 'undefined') {
      window.googleSignInResponse = callback;
    }
  }, []);
  const [scriptLoaded, setScriptLoaded] = (0, react_1.useState)(false);
  (0, react_1.useEffect)(() => {
    loadScript(document, 'script', 'google-login', 'https://accounts.google.com/gsi/client', () => {
      console.log('!!! loaded!');
      setScriptLoaded(true);
    });
    return function cleanup() {
      removeScript(document, 'google-login');
    };
  }, []);
  console.log('scriptLoaded: ', scriptLoaded);
  return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
    children: [(0, jsx_runtime_1.jsx)("div", {
      id: "g_id_onload",
      "data-client_id": clientId,
      "data-auto_prompt": "false",
      "data-callback": "googleSignInResponse"
    }, void 0), (0, jsx_runtime_1.jsx)("div", {
      className: "g_id_signin",
      "data-type": "standard",
      "data-size": "medium",
      "data-theme": "outline",
      "data-text": "continue_with",
      "data-shape": "rectangular",
      "data-logo_alignment": "center",
      "data-ux_mode": "popup",
      "data-width": width
    }, void 0)]
  }, void 0);
};

exports.default = GoogleSigninButton;